<script lang="ts">
    import type { ITrxCc } from '../../order'
    import Icon from '@iconify/svelte'

    import { cardData } from 'wdom/utils/credit_card'
    import type { ICardData } from 'wdom/utils/credit_card'

    import Date from 'hydria/components/Date.svelte'

    interface Props {
        trx: ITrxCc
    }

    let { trx }: Props = $props()

    let expandTransaction = $state(false)
    let expandQuery = $state(false)
    let expandResponse = $state(false)

    let cardMeta: ICardData | undefined
    let cardNumber: string | undefined = $state()
    let fakeNum = trx.data.query ? trx.data.query.card_number_first_digits : ''
    let totDigits = trx.data.query ? trx.data.query.card_number_total_digits : 16
    let firstDigits = trx.data.query ? trx.data.query.card_number_first_digits : ''
    let lastDigits = trx.data.query ? trx.data.query.card_number_last_digits : ''
    // probably mastercards, but not necessarily.. better not to falsely claim it's MC when it might not be, keep commented
    // if (fakeNum == '22') fakeNum += '21'
    // else if (fakeNum == '27') fakeNum += '20'
    fakeNum = fakeNum.padEnd(totDigits - fakeNum.length - lastDigits.length, '0') + lastDigits
    cardMeta = cardData(fakeNum)
    if (cardMeta == null && totDigits == 16) {
        cardMeta = { tag: '-', text: '', innRanges: [], lengths: [16], cvdLength: 3, masks: ['0000 0000 0000 0000'] }
    }

    cardNumber = undefined
    if (cardMeta) {
        let i = cardMeta.lengths.indexOf(totDigits)
        if (i >= 0) {
            cardNumber = cardMeta.masks[i].replaceAll('0', 'X')
            for (const c of firstDigits) {
                cardNumber = cardNumber.replace('X', c)
            }
            for (const c of lastDigits.split('').reverse()) {
                cardNumber = cardNumber.replace(/(.*)X/, `$1${c}`)
            }
        }
    }
    if (!cardNumber) {
        cardNumber = firstDigits + 'X'.padEnd(totDigits - firstDigits.length - lastDigits.length, 'X') + lastDigits
    }
</script>

<h4>Carte de crédit / {trx.data.processor[0].toLocaleUpperCase() + trx.data.processor.slice(1)}</h4>

<table class="table">
    <caption>Transaction <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandTransaction} onclick={() => (expandTransaction = !expandTransaction)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        <tr><th>Succès</th><td>{trx.success ? 'Oui' : 'Non'}</td></tr>
        <tr><th>Statut</th><td>{trx.status}</td></tr>
        {#if expandTransaction}
            <tr><th>Méthode</th><td>{trx.payment_method}</td></tr>
            <tr><th>Processor</th><td>{trx.data.processor}</td></tr>
            <tr><th>Date</th><td><Date value={trx.stamp} format="h-table" /></td></tr>
            <tr><th>Address IP</th><td>{trx.ip_address}</td></tr>
            <tr><th>ID</th><td>{trx.id}</td></tr>
        {/if}
    </tbody>
</table>

<table class="table">
    <caption>Requête <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandQuery} onclick={() => (expandQuery = !expandQuery)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        {#if trx.data.query}
            <tr><th>Nom sur la carte</th><td>{trx.data.query.name_on_card}</td></tr>
            <tr><th>Numéro de carte</th><td>{cardNumber}</td></tr>
            <tr><th>Expiration</th><td>{trx.data.query.expiration_month} / {trx.data.query.expiration_year}</td></tr>
            {#if expandQuery}
                <tr><th>CSC</th><td>{trx.data.query.with_cvd ? 'Oui' : 'Non'}</td></tr>
                <tr><th>Montant</th><td>{trx.data.query.amount}</td></tr>
                <tr><th>Adresse</th><td>{trx.data.query.has_billing_address ? 'Oui' : 'Non'}</td></tr>
                <tr><th>Langue</th><td>{trx.data.query.language}</td></tr>
                <tr><th>Date</th><td><Date value={trx.data.query.stamp} format="h-table" /></td></tr>
            {/if}
        {/if}
    </tbody>
</table>

<table class="table">
    <caption>Réponse <button type="button" class="btn btn-sm btn-outline-secondary float-end" class:active={expandResponse} onclick={() => (expandResponse = !expandResponse)}><Icon inline icon="fa:arrows-v" /></button></caption>
    <tbody>
        {#if trx.data.response}
            <tr><th>Approuvé</th><td>{trx.data.response.approved ? 'Oui' : 'Non'}</td></tr>
            <tr><th>Code d’auth.</th><td>{trx.data.response.auth_code}</td></tr>
            {#if expandResponse}
                <tr><th>Montant</th><td>{trx.data.response.transaction_amount}</td></tr>
                <tr><th>Message</th><td>{trx.data.response.beanstream_message_text}</td></tr>
                <tr><th>ID Message</th><td>{trx.data.response.beanstream_message_id}</td></tr>
                <tr><th>Statut CSC</th><td>{trx.data.response.cvd_status}</td></tr>
                <tr><th>Code CSC</th><td>{trx.data.response.cvd_code}</td></tr>
                <tr><th>ID Transaction</th><td>{trx.data.response.transaction_id}</td></tr>
                <tr><th>Date</th><td><Date value={trx.data.response.stamp} format="h-table" /></td></tr>
            {/if}
        {/if}
    </tbody>
</table>
